'use strict';

function AssignationColorDirective() {
  return {
    restrict: 'A',
    replace: false,
    link: function(scope, element, attrs, controller) {
      if (attrs.assignationColorStatus == 'done') {
        element.addClass('done-color');
      } else if (attrs.assignationColorStatus == 'notDone') {
        element.addClass('notdone-color');
      }
    }
  };
}

export default AssignationColorDirective;
